import { InteractionTypes } from '@/entities/interaction';
import { InteractionList } from '@/widgets/interaction-list';

export default function MeetAcceptedPage() {
  return (
    <InteractionList
      type={InteractionTypes.MEET}
      direction="bidirectional"
      title="Rendez-vous acceptés"
      emptyMessage="Aucun rendez-vous accepté pour le moment."
    />
  );
}
